module.exports = require('./PageHome');


/** WEBPACK FOOTER **
 ** ./demo/src/pages/home/index.js
 **/